import { Link } from 'react-router-dom';

import useTranslation from 'Hooks/useTranslation';

import 'scss/components/content/account.scss';

export default function AccountRegisterWelcome() {

	const { t } = useTranslation();

	const welcome_msg = t('account.welcome.hello') + ', ' + t('account.register.inProcess');

	return (

		<div id='account-page' className='account-register-welcome'>
			<p>{ welcome_msg }</p>
			<Link to={`/`}>{ t('homepage') }</Link>
		</div>
	);
};
